/*
 * Copyright (c) 2020 NOOGA DEVELOPMENT, All rights reserved.
 * Author Raman Kremko <raman.kremko@noogadev.com>
 */

import {
    TemplateExecutionListDTO,
    TemplateExecutionsSearchParams,
    TEMPLATES_EXECUTIONS_SORT_TYPES,
} from '../api/alerts/alertsClient.typings';

import { AlertsExecutionActionType, AlertsExecutionsAction } from '../actions/alertsExecutionsActions';
import { actionTypes } from 'redux-router5';
import { AnyAction } from 'redux';

export interface AlertsExecutionsState {
    executionsList: TemplateExecutionListDTO;
    executionsListSearchParams: TemplateExecutionsSearchParams;
    isLoading: boolean;
}

const initialState: AlertsExecutionsState = {
    executionsList: {
        count: 0,
        alertsChecksExecutions: [],
    },
    executionsListSearchParams: {
        limit: 20,
        offset: 0,
        sort: TEMPLATES_EXECUTIONS_SORT_TYPES[0],
    },
    isLoading: false,
};

export function alertsExecutionsReducer(
    state: AlertsExecutionsState = initialState,
    action: AlertsExecutionsAction & AnyAction,
): AlertsExecutionsState {
    switch (action.type) {
        case AlertsExecutionActionType.FETCH_ALERTS_EXECUTIONS_PAGE:
            return {
                ...state,
                executionsListSearchParams: action.payload.params,
            };

        case AlertsExecutionActionType.FETCH_ALERTS_EXECUTIONS_PAGE_SUCCESS:
            return {
                ...state,
                executionsList: action.payload,
            };

        case actionTypes.TRANSITION_START:
            return {
                ...state,
                executionsListSearchParams: {
                    ...state.executionsListSearchParams,
                    offset: 0,
                },
            };

        case AlertsExecutionActionType.ALERTS_EXECUTION_PAGE_ERROR:
            return {
                ...state,
                isLoading: false,
            };

        case AlertsExecutionActionType.CLOSE_ALERTS_EXECUTIONS_PAGE:
            return initialState;
    }

    return state;
}
